import React, { useState, useEffect} from 'react';
import dataProvider from '../../lib/dataProvider';
import { useLocation } from 'react-router-dom';
import { useTranslate } from 'react-admin';
import { getInfoValue, isHauptadmin, isReseller  } from '../../lib/globalData';
import DataGrid from '../../lib/DataGrid';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
import DoneIcon from '@mui/icons-material/Done';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandAllIcon from 'mdi-react/ChevronDoubleDownIcon';
import ReduceAllIcon from 'mdi-react/ChevronDoubleUpIcon';

import RefreshIcon from '@mui/icons-material/Refresh';

import OkIcon from '../../img/if/ok.svg';
import OffIcon from '../../img/if/off.svg';
import ErrorIcon from '../../img/if/error.svg';
import AddIcon from '../../img/if/add.svg';
import CheckIcon from '@mui/icons-material/Check';

const calcValue = (value) => {
  if (value === '-' || value === undefined || value === null) return '-';
  if (value===true || value===1 || value==='1') return 1;
  if (value===false || value===0 || value==='0') return 0;
  return value;
};

const statusStyle = (value) => {
  if (value===1) return {fontWeight:'bold', color:'green'};
  if (value===0) return {fontWeight:'bold', color:'red'};
  return {};
};

const detailsDay = (overview, aktiveRate, info, tag) => {
  if (!overview.details2 || !overview.ratelist[aktiveRate]) return false;
  const rateid = overview.ratelist[aktiveRate].ids[info.id];
  const details = overview.details2[info.id+':'+rateid] || overview.details2[info.key_ori] || overview.details2[info.id];
  if (!details) return false;
  const days = details[info.id] || details;
  return days[tag] || false;
};

const consolidatedCalcValue = (calc, key) => {
  if (!calc || !calc.rooms) return '-';
  var values = [];
  Object.keys(calc.rooms).forEach(roomid=>{
    Object.keys(calc.rooms[roomid] || {}).forEach(occupancyType=>{
      const roomCalc = calc.rooms[roomid][occupancyType];
      if (roomCalc && roomCalc[key] !== undefined) {
        values.push(calcValue(roomCalc[key]));
      }
    });
  });
  if (!values.length) return '-';
  return values.every(value=>value===values[0])?values[0]:'x';
};

const IfPortal = (props) => {
  const tl = useTranslate();
  
  const [value, setValue] = useState(0);
  const [aktionen, setAktionen] = useState(false);
  const [data, setData] = useState({});
  const [overview, setOverview] = useState({});
  const [portalinfo, setPortalinfo] = useState([]);
  const [portalinfoDisp, setPortalinfoDisp] = useState([]);
  const [portalinfoHelp, setPortalinfoHelp] = useState([]);
  const [details, setDetails] = useState({});
  const [detailData, setDetailData] = useState(false);
  const [technicalDetails, setTechnicalDetails] = useState({});
  const [detailDialog, setDetailDialog] = useState(false);
  const [overviewLoading, setOverviewLoading] = useState(true);
  const [rmiList, setRmiList] = useState(false);
  
  const [progress, setProgress] = useState(false);
  const [progAktion, setProgAktion] = useState(false);
  const [logid, setLogid] = useState(false);
  
  const [startDate, setStartDate] = useState(new Date());
  const [anzTage, setAnzTage] = useState(8);
  const [lnr, setLnR] = useState(true);
  const [aktiveRate, setAktiveRate] = useState(-1);
  
  const [piEditId, setPiEditId] = useState(0);
  const [piReload, setPiReload] = useState(0);

  const [copied, setCopy] = useState(false);

  const location = useLocation();
  const params = location.pathname.split("/");
  const agent = params[2];
  
  useEffect(() => {
    dataProvider.getOne('ifAktionen', { id: agent })
      .then(res  => { 
        setAktionen(res.data);
      })
  }, [agent]);

  useEffect(() => {
    setOverviewLoading(true);
    dataProvider.getList('ifOverview', { filter: {agent: agent, startDate:startDate.toISOString().substr(0,10), anzTage:anzTage, lastNewRes: lnr, }, pagination: { page: 1, perPage: 1 }, sort: { field: 'date', order: 'DESC' },})
      .then(res  => {
        if (res.data && res.data[0]) {
          const ov = res.data[0];
          var ar = aktiveRate;
          for (var r=0; r < ov.ratelist.length;r++) {
            for (var k=0; k < ov.portrbt.length;k++) {
              var info = ov.portrbt[k];
              var rbt = info.id; 
              var rateid = ov.ratelist[r].ids[rbt];
              for(var tag in ov.availRate.pogr_datum) {
                var pogrid = ov.availRate.pogr_datum[tag];
                var pogrinfo = ov.availRate.pogr_info[pogrid];
                if (pogrinfo.preis[rbt] && pogrinfo.preis[rbt][rateid] && pogrinfo.preis[rbt][rateid].open) {
                  ov.ratelist[r].anyopen = true;
                }
                else {
                  ov.ratelist[r].anyclosed = true;
                }
              }
            }
            if (ov.ratelist[r].anyopen && ov.ratelist[r].anyclosed) {
              ov.ratelist[r].color = '#F9F96E'
              if (ar === -1) {
                ar = r;
              }
            }
            else if (ov.ratelist[r].anyopen) {
              ov.ratelist[r].color = '#E2F9CB';
              if (ar === -1) {
                ar = r;
              }
            }
            else {
              ov.ratelist[r].color = '#F9D8CB'
            }
          }
          if (ar === -1) {
            ar =0;
          }
          setAktiveRate(ar);
          setOverview(ov);
        } 
      })
      .finally(() => setOverviewLoading(false))
  }, [startDate, anzTage, lnr, agent, aktiveRate]);

  
  useEffect(() => {
    const ov = overview;
    var det = {};
    if (ov.portrbt && aktionen && ov.ratelist[aktiveRate]) {

      var resttext = {};
      if (aktionen.optionMinNacht) { resttext.min_nacht = 'min. nights'};
      if (aktionen.optionMaxNacht) { resttext.max_nacht = 'max. nights'};

      const decimal = ov.decimal; 
      for (var k=0; k < ov.portrbt.length;k++) {
        var info = ov.portrbt[k];
        var rbt = info.id; 

        var roomlist = [];
        var roomoglist = [];
        
        var occlist = [];
        var allowlist = [];
        var restrlist = [];
        var tage = [];
        if (aktionen.optionClosedForArrival) { allowlist.push('allow arrival')};
        if (aktionen.optionClosedForDeparture) { allowlist.push('allow departure')};
        det[rbt] = [];
        for(var tag in ov.availRate.pogr_datum) {
          var pogrid = ov.availRate.pogr_datum[tag];
          var pogrinfo = ov.availRate.pogr_info[pogrid];
          var restrictions = ov.availRate.restrictions[tag];
          
          if (!pogrinfo) continue;
          
          var rooms = pogrinfo.rooms[rbt];
          if (roomlist.indexOf(rooms) === -1) {
            roomlist.push(rooms);
            roomoglist.push(ov.gruppen[tag].onlinegr);
          }
          
          var rateid = ov.ratelist[aktiveRate].ids[rbt];
          var preis = null;
          var detlist = {};
          const restriction = restrictions && restrictions[rbt];
          if (pogrinfo.preis[rbt]) {
            preis = pogrinfo.preis[rbt][rateid];

            for (var n in preis) {
              if ((!isNaN(n) && isFinite(n)) || n==='default') {
                var p = parseFloat(preis[n]);
                detlist[n] = p.toFixed(decimal);
                if (occlist.indexOf(n) === -1) {
                  occlist.push(n);
                }
              }
            }
            if (restriction) {
              for (n in restriction) {
                if (resttext[n]) {
                  detlist[resttext[n]] = restriction[n];
                  if (restrlist.indexOf(resttext[n]) === -1) {
                    restrlist.push(resttext[n]);
                  }
                }
              }
            }
          }
          const day = detailsDay(ov, aktiveRate, info, tag);
          const calc = day && day._calc;
          if (aktionen.optionClosedForArrival) {
            var allowArrival = consolidatedCalcValue(calc, 'allowArrival');
            const noarrival = calcValue(restriction && restriction.noarrival);
            if (allowArrival==='-' && (noarrival===0 || noarrival===1)) {
              allowArrival = noarrival?0:1;
            }
            detlist['allow arrival'] = allowArrival;
          }
          if (aktionen.optionClosedForDeparture) {
            var allowDeparture = consolidatedCalcValue(calc, 'allowDeparture');
            const nodeparture = calcValue(restriction && restriction.nodeparture);
            if (allowDeparture==='-' && (nodeparture===0 || nodeparture===1)) {
              allowDeparture = nodeparture?0:1;
            }
            detlist['allow departure'] = allowDeparture;
          }
          tage.push(detlist);
        }
        det[rbt] = {headlist:occlist.sort().concat(allowlist, restrlist), tage:tage, roomlist:roomlist, roomoglist:roomoglist };
      }
    }
    setDetailData(det);
  }, [aktionen, overview, aktiveRate]);
  
  const UpdateRmiList = (pi) => {
    var rmil = {};
    for (var i=0; i<pi.length; i++) {
      if (pi[i].schluessel.substr(0,4)==='rmi_') {
        rmil[pi[i].schluessel.substr(4)] = pi[i].wert;
      }
    }
    setRmiList(rmil);
  }
    
  useEffect(() => {
    dataProvider.getList('ifPortalinfo', { filter: {agent: agent}, pagination: { page: 1, perPage: 1000 }, sort: { field: 'schluessel', order: 'ASC' },})
      .then(res  => {
        if (res.data && res.data[0]) {
          const pi = res.data;
          setPortalinfo(pi);
          UpdateRmiList(pi)
        } 
      })
  }, [piReload, agent]);
  
  useEffect(() => {
    dataProvider.getList('ifPortalinfo', { filter: {agent: agent, help: true}, pagination: { page: 1, perPage: 1000 }, sort: { field: 'schluessel', order: 'ASC' },})
      .then(res  => {
        if (res.data && res.data[0]) {
          setPortalinfoHelp(res.data);
        } 
      })
  }, [agent]);

  
  useEffect(() => {
    const SetKeyMarks = () => {
      if (!portalinfo.length || !portalinfoHelp.length) return;
      var pi = portalinfo;
      for (var i=0; i<portalinfo.length; i++) {
        pi[i].mark = 2;
        for (var j=0; j<portalinfoHelp.length; j++) {
          if (portalinfoHelp[j].reg) {
            var re = new RegExp(portalinfoHelp[j].reg,"g");
            if (pi[i].schluessel.match(re)) {
              pi[i].mark = portalinfoHelp[j].glob?0:1;
              break;
            }
          }
          else {
            if (pi[i].schluessel === portalinfoHelp[j].key) {
              pi[i].mark = portalinfoHelp[j].glob?0:1;
              break;
            }
            
          }
        }
      }
      setPortalinfoDisp(pi);
    }
    SetKeyMarks();
  }, [portalinfo, portalinfoHelp, agent]);
  
  const Help = (props) => {
    if (!portalinfoHelp.length) return null;
    var prefglob = true;
    return (
      <table><tbody>
        <tr><td><b>All interfaces</b></td></tr>
    {portalinfoHelp.map(row => {
      if (!row.text) return null;
      var jsx = [];
      if (!row.glob && prefglob) {
        prefglob = false
        jsx.push(<tr key={"t-"+row.id}><td><b>{aktionen.lang}</b></td></tr>);
      }
      jsx.push(<tr key={row.id}><td>{row.key}</td><td>{row.text}</td></tr>);
      return jsx;
    })}  
      </tbody></table>
    
    )
  }
  
  const DoRefresh = (props) => (
    <RefreshIcon style={{position:"relative", top:"10px", cursor:"pointer"}} onClick={props.onClick} />
  )
  
  const handleChange = (key) => (event) => {
    setData((d)=>{d[key]=event.target.value; return d});
  };

  const handleCopyClick = (text) => () => {
    setCopy(text+' copied');
  };
  
  const handleAktion = (aktion) => (event) => {
    dataProvider.update('ifAktionen', { id: agent, data: {aktion: aktion, data:data} })
      .then(res  => { 
        if (aktion!=='RoomInfo') {
          setAktionen(res.data);
        }
        if (res.data.result && res.data.result.logid>0) {
          setLogid(res.data.result.logid);
          setProgress(1);
        }
        if (res.data.msg && res.data.msg!=='') {
          alert(res.data.msg)
        }
        setPiReload(piReload+1);
        setProgAktion(aktion);
      })
  };
  
  useEffect(() => {
    if (progress === false) return;
    dataProvider.update('ifAktionen', { id: agent, data: {aktion: 'getProgress'} })
      .then(res  => { 
        if (res.data.pos < logid) {
          setTimeout(() => { setProgress(progress + 1); }, 1000);          
        }
        else {
          setPiReload(piReload+1);
          setProgress(false);
        }
      })
      // eslint-disable-next-line
  }, [progress, agent, logid]);
  
  const ActionBu = (props) => (
    <Button variant="contained" color="primary" {...props}>{tl(props.text)}</Button>
  )
  const Reload = () => {
    setPiReload(piReload+1);
  }
  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };
  const handleScroll = (offset) => (ev) => {
    var d = new Date(startDate.getFullYear(),startDate.getMonth(),startDate.getDate() + offset * anzTage,4);
    setStartDate(d);
  };
  const handleDate = (event) => {
    var d = new Date(event.target.value)
    setStartDate(d);
  };
  const handleAnzTage = (event) => {
    setAnzTage(event.target.value);
  };
  const handleLnR = (event) => {
    setLnR(event.target.checked);
  };
  const handleOverrideDel = (event) => {
    setData((d)=>{d['del']=event.target.checked; return d});
  };
  
  const handleDetailsClick = (rid) => (event, newValue) => {
    var det = {...details, [rid]:(details[rid]?false:true)};
    var open = false;
    for (var k in det) {
      if (det[k]) open = true;
    }
    if (!open) {det = {}};
    setDetails(det);
  };
  const handleAllDetailsClick = (set) => (event, newValue) => {
    var det = {};
    if (set) {
      overview.portrbt.forEach(info=>{
        det[info.id] = true;
      });
    }
    setDetails(det);
  };
  const handleRateClick = (rid) => (event, newValue) => {
    setAktiveRate(rid);
  };
  const handleTechnicalDetailsClick = (rid) => () => {
    setTechnicalDetails({...technicalDetails, [rid]:!technicalDetails[rid]});
  };
  const handleDetailDialogClose = () => {
    setDetailDialog(false);
  };

  const rateValue = (value, rateid) => {
    if (!value) return '-';
    const rate = value[rateid] || value.ALL || value[Object.keys(value)[0]];
    if (!rate) return '-';
    switch (parseInt(rate.rate_typ)) {
      case -2: return 'undef.';
      case -1: return 'man.';
      case 0: return 'closed';
      case 1: return 'open';
      case 2: return rate.rate_value+'%';
      case 3: return rate.rate_value+' '+overview.currency;
      default: return '-';
    }
  };
  const rawDetails = (info, tag) => {
    const day = detailsDay(overview, aktiveRate, info, tag);
    if (!day) return [];
    const calcRooms = day._calc && day._calc.rooms?day._calc.rooms:{};
    var rows = [];
    var added = {};
    Object.keys(day).filter(size=>size!=='_calc').forEach(size=>{
      const occupancy = day[size];
      Object.keys(occupancy || {}).forEach(type=>{
        Object.keys(occupancy[type] || {}).forEach(roomtype=>{
          Object.keys(occupancy[type][roomtype] || {}).forEach(roomid=>{
            const result = occupancy[type][roomtype][roomid];
            const rawOccupancyType = size+'|'+type;
            const roomCalc = calcRooms[roomid] || {};
            var occupancyType = rawOccupancyType;
            if (!roomCalc[occupancyType] && type==='dorm') {
              const candidates = Object.keys(roomCalc).filter(key=>key.indexOf(size+'|dorm.')===0);
              const resultCandidate = candidates.find(key=>String(result).indexOf(key.split('|')[1])>=0);
              const genderType = {'0':'dorm.f', '1':'dorm.m', '2':'dorm.x'}[String(info.geschlecht)];
              const genderCandidate = candidates.find(key=>key===size+'|'+genderType);
              if (candidates.length) {
                occupancyType = resultCandidate || genderCandidate || candidates[0];
              }
            }
            rows.push({occupancyType:occupancyType, roomid:roomid, result:result, calc:roomCalc[occupancyType]});
            added[roomid+'|'+occupancyType] = true;
          });
        });
      });
    });
    Object.keys(calcRooms).forEach(roomid=>{
      Object.keys(calcRooms[roomid] || {}).forEach(occupancyType=>{
        if (!added[roomid+'|'+occupancyType]) {
          rows.push({occupancyType:occupancyType, roomid:roomid, result:'-', calc:calcRooms[roomid][occupancyType]});
        }
      });
    });
    rows.sort((a, b)=>{
      const roomCompare = String(roomName(a.roomid)).localeCompare(String(roomName(b.roomid)), undefined, {numeric:true});
      return roomCompare || String(a.occupancyType).localeCompare(String(b.occupancyType), undefined, {numeric:true});
    });
    return rows;
  };
  const roomName = (roomid) => {
    const room = overview.roomNames && overview.roomNames.find(row=>String(row.zimmer_id)===String(roomid));
    const bed = overview.bedNames && overview.bedNames.find(row=>String(row.bett_id)===String(roomid));
    if (room || bed) return room?room.bezeichnung:bed.bedname;
    for (var tag in overview.details || {}) {
      for (var roomtype in overview.details[tag]) {
        const rooms = overview.details[tag][roomtype];
        for (var name in rooms) {
          if (rooms[name] && String(rooms[name].id_zimmer)===String(roomid)) return name;
        }
      }
    }
    return roomid;
  };
  const openDetailDialog = (info, tag) => () => {
    setDetailDialog({info:info, tag:tag, rows:rawDetails(info, tag)});
  };
  
  const handleSchluessel = (ev) => {
    React.PiEditKey = ev.target.value;
  }
  const handleWert = (ev) => {
    React.PiEditValue = ev.target.value;
  }        
  const piEdit = (id) => {
    setPiEditId(id);          
    portalinfo.map(el=>{
      if (el.id===id) {
        React.PiEditKey = el.schluessel;
        React.PiEditValue = el.wert;
      }
      return true;
    });
    return true;
  }
  const piRemove = (id) => {
    dataProvider.delete('ifPortalinfo', { id: id })
      .then(res  => { 
        setPiReload(piReload+1);
      })
  }
  const piAdd = () => {
    setPiEditId(-1);
    React.PiEditKey = '';
    React.PiEditValue = '';
    window.scroll({ top: 0, left: 0, behavior: 'smooth'});
  }
  const piCancel = () => {
    setPiEditId(0);
  }
  const piSave = () => {
    dataProvider.update('ifPortalinfo', { 
        id: piEditId, data: {id: piEditId, id_agent: aktionen.id_agent, schluessel: React.PiEditKey, wert:React.PiEditValue} }
      )
      .then(res  => { 
        setPiReload(piReload+1);
        setPiEditId(0);
      })
  }
  
  const TabPanel = (props) => {
    const { children, value, index } = props;
             
    if (value!==index) return null;
    return (
      <div style={{marginTop:"1em"}}>
        {children}
      </div>
    );
  }    
  
  var tage = [];
  var hasYield = false;
  if (overview.availRate) {
    for(var tag in overview.availRate.pogr_datum) {
      if (overview.gruppen[tag]) {
        tage.push(tag);
        if (overview.gruppen[tag].id_parent > 0) {
          hasYield = true;      
        }
      }
    }
  }
  var spancnt = 0;
  var spancnt2 = 1;
  var spancnt3 = 1;
  var formatter = new Intl.DateTimeFormat(getInfoValue('id_sprache')===1?"de-de":"en-us", { month: 'long'});

  const columns = [
    { field: 'schluessel', headerName: 'Key', width: 70, mark:['#EEE','#FFDB00'] },
    { field: 'wert', headerName: 'Value', width: 70 },
  ];
             
  const stat = aktionen.status;             
  const icon = stat==='up'?OkIcon:(stat==='down'?OffIcon:(stat==='notconfigured'?AddIcon:ErrorIcon)); 

  const SetupInput = ({source, label, value, prelbl='', postlbl='', inputWidth='15', comp='text', iSource='', ...props}) => {
    const infosource = iSource!==''?iSource:source
    return (
      <div style={{display: 'flex', marginBottom: '1em'}}>
        <div style={{width: '40em', alignContent: 'flex-end'}}>
          <div>{label}</div>
          <div style={comp==='label'?{fontWeight: 'bold', color: 'red', marginTop: '1em'}:{fontWeight: 'bold'}}>{aktionen?.setupinfo[infosource]}</div>
        </div>
        {prelbl && <div style={{alignContent: 'flex-end', marginRight: '.5em'}}>{prelbl}</div>}
        {comp==='text' && <TextField sx={{mt: '0', mb: '0', width: inputWidth+'em'}} defaultValue={value} id={source} key={source} onChange={handleChange(source)} label="" />}
        {comp==='label' && <div style={{marginTop: '1em'}}>{aktionen[source]??''}</div>}
        {comp==='check' && <Switch sx={{mt: '0', mb: '0'}} id={source} key={source} checked={value} onChange={handleChange(source)} label="" />}
        {comp==='select' && <Select {...props} native sx={{mt: '0', mb: '0', width: inputWidth+'em'}} id={source} key={source} onChange={handleChange(source)} defaultValue={value} label="" />}
        <div style={{alignContent: 'flex-end', marginLeft: '.5em'}}>{postlbl}</div>
      </div>
    )
  }

  const PortalSetup = () => {
    const nc = aktionen?.notconfigured
    return (
      <>
        {nc?.res_email===true && <SetupInput source="res_email" label="E-Mail 2 (for reservation confirmation)" value={aktionen?.setupvalues?.res_email} inputWidth='30' />}
        {nc?.kom_buchung1===true && <SetupInput source="kom_buchung" iSource="kom_buchung1" label="Kommission für Buchung" postlbl="%, negative Werte: in Hauptwährung" inputWidth='5' value={aktionen?.setupvalues?.kom_buchung1} />}
        {nc?.ontop===true && <SetupInput source="aufpreis" iSource="ontop" label="Kommission als Aufpreis" comp='check' value={false} />}
        {nc?.payment===true && <SetupInput source="id_zahlungsart" iSource="payment" label="Anzahlung" comp='select' value={0} >
          {aktionen?.zahlungsarten && Object.entries(aktionen?.zahlungsarten).map(([id, za]) => (
            <option value={id} key={id}>
              {za}
            </option>
            ))}
          </SetupInput>}
        {nc?.hostelnumber===true && <SetupInput source="hostelnumber" label={aktionen?.kurz+": hostelnumber"} postlbl={aktionen?.id_agent===4?'Suche eine Reservation und verwende den Teil der Nummer vor dem "-" (z.B. HB-Nummer 39424-2980406, Hostelnummer 39424) oder das Hostel auf hostelbookers.com suchen und den Link zu den Detailinformationen kopieren und darin den Wert von "intpropertyid" auslesen.':''} />}
        {nc?.hostelname===true && <SetupInput source="hostelname" label={aktionen?.kurz+": hostelname"} />}
        {nc?.loginname===true && <SetupInput source="loginname" label={aktionen?.kurz+": Loginname"} />}
        {nc?.partner_url===true && <SetupInput source="partnerURL" iSource="partner_url" label={aktionen?.kurz+": Partner URL"} inputWidth='40' />}
        {nc?.portalpwd===true && <SetupInput source="password" iSource="portalpwd" label={aktionen?.kurz+": password"} />}
        {nc?.until===true && <SetupInput source="lastNewRes" iSource="until" label={aktionen?.kurz+": last new reservation"} prelbl="until" postlbl="hour(s) before 24:00 of arrival day" inputWidth='5' value={0} />}
        {nc?.invitation===true && <SetupInput source="invitation" label="E-Mail to send invitation for channex-system" value={aktionen?.setupvalues?.invitation} inputWidth='30' />}
        {nc?.datacenter===true && <SetupInput source="datacenter" label="Datacenter" comp='select' >
            <option value='APAC' key='APAC'>APAC</option>
            <option value='EMEA' key='EMEA'>EMEA</option>
          </SetupInput>}
        {nc?.liststatus===true && <SetupInput source="liststatus" label="" comp='label' />}
        <div style={{display: 'flex', marginBottom: '1em'}}>
          <div style={{width: '40em', alignContent: 'flex-end'}}></div>
          <div>
            <ActionBu text="bw.if.portal.setup" onClick={handleAktion('setup')} />
          </div>
        </div>
      </>
    )
  }
             
  const PortalInfo = () => (
    <>
      {piEditId!==0 &&
        <>
          <TextField id="tfkey" key="tfkey" label="Key" variant="filled" defaultValue={React.PiEditKey} onChange={handleSchluessel} />
          <TextField id="tfval" key="tfval" label="Value" variant="filled" defaultValue={React.PiEditValue} onChange={handleWert} fullWidth />
          <Button variant="contained" color="primary" onClick={piSave} style={{margin:"1em 1em 1em 0"}}>Save</Button>
          <Button variant="contained" color="primary" onClick={piCancel}>Cancel</Button>
          <Help />
        </>
      }
        <DataGrid rows={portalinfoDisp} columns={columns} edit={isHauptadmin()?piEdit:null} remove={isHauptadmin()?piRemove:null} />
        <Button variant="contained" color="primary" onClick={piAdd} style={{margin:"1em 1em 1em 0"}}>Add</Button>
        <Help />
    </>
  )

  const ImportExport = () => {
    const dat = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    //portalinfo
    const jsonString = JSON.stringify(portalinfo.map(val => ({ schluessel: val.schluessel, wert: val.wert })))
    var phpVar = '  var $portalinfo'+dat+'_'+getInfoValue('id_hostel')+' = array(\n'
    phpVar = phpVar+portalinfo.map(val => ('    "'+val.schluessel+'" => \''+val.wert+'\',\n')).join('')
    phpVar = phpVar+'  );'

    const gI = aktionen?.globalInfo
    const EmailDisplay = ({k, val}) => {
      const emails = gI?.list[k]
      return (
        <>
          <div><b>-&gt; Reseller {k}</b> ({val?.up} Hostels) {JSON.stringify(val)}</div>
          <div style={{ marginBottom: '1em', maxWidth: '84vw'}}>{Object.values(emails).join(', ')}</div>
        </>
      )
    }
    return (
      <>
        <div style={{fontWeight: 'bold'}}>PHP-Array: {copied}</div>
        <CopyToClipboard onCopy={handleCopyClick('PHP var ')} text={phpVar}>
          <div style={{margin: '.4em', padding: '.4em', backgroundColor: 'rgba(0,0,0,0.08)', borderRadius: '.5em', maxWidth: '84vw'}}>
            <pre style={{textWrapMode: 'wrap'}}>{phpVar}</pre>
          </div>
        </CopyToClipboard>
        <div style={{fontWeight: 'bold', marginTop: '.5em'}}>JSON-String: {copied}</div>
        <CopyToClipboard onCopy={handleCopyClick('JSON-String ')} text={jsonString}>
          <div style={{margin: '.4em', padding: '.4em', backgroundColor: 'rgba(0,0,0,0.08)', borderRadius: '.5em', maxWidth: '84vw'}}>{jsonString}</div>
        </CopyToClipboard>
        <div style={{fontWeight: 'bold', marginTop: '.5em'}}>Import: (json-string)</div>
        <div style={{marginLeft: '.4em'}}>
          <div>
            <TextField id="json-string" key="json-string" variant="filled" onChange={handleChange('jsonData')} multiline rows={4} fullWidth />
          </div>
          <div>
            <FormControlLabel control={<Switch onChange={handleOverrideDel} name="override" color="primary" />} label="override/delete" style={{marginBottom:'1em'}}/>
          </div>
          <div>
            <ActionBu text="bw.if.portal.importLbl" onClick={handleAktion('import')} />
          </div>
        </div>
        <div style={{marginTop: '1.5em'}}><b>Emails: (Total {gI?.stat[0]?.up} Hostels)</b> {JSON.stringify(gI?.stat[0])}</div>
        { gI?.stat && Object.keys(gI.stat).map(k => 
            <EmailDisplay key={k} k={k} val={gI.stat[k]} />
          )
        }
        <div>
          <div style={{maxWidth: '84vw', overflow: 'scroll'}}>{gI?.sql}</div>
          <pre style={{maxWidth: '84vw'}}>{JSON.stringify(gI?.list, null, 2)}</pre>
          <pre style={{maxWidth: '84vw'}}>{JSON.stringify(gI?.list3, null, 2)}</pre>
        </div>
      </>
    )
  }
  
  const Synctime = () => (
    <tr >
      <td align="right">{tl("bw.if.portal.timeSync")}</td>
      <td>
        {aktionen.timeSyncMin} - {aktionen.timeSyncMax}
      </td>
      <td>
        <select defaultValue={aktionen.timeUntil} onChange={handleChange('until')}>
          <option value={aktionen.timeUntil}>{aktionen.timeUntil}</option>
          <option value="1 month">1 month</option>
          <option value="2 month">2 month</option>
          <option value="3 month">3 month</option>
          <option value="4 month">4 month</option>
          <option value="5 month">5 month</option>
          <option value="6 month">6 month</option>
          <option value="7 month">7 month</option>
          <option value="8 month">8 month</option>
          <option value="9 month">9 month</option>
          <option value="10 month">10 month</option>
          <option value="11 month">11 month</option>
          <option value="12 month">12 month</option>
          <option value="13 month">13 month</option>
        </select>&nbsp;
        <ActionBu text="bw.if.portal.timeSet" onClick={handleAktion('SetSync')} />
      </td>
    </tr>
  )
  
  if (!startDate) return null;
  
  var configfields = [];
  if (aktionen.aktionConfig_fields) {
    var firstadm = true;
    const cf = aktionen.aktionConfig_fields;
    for (var i=0;i<=cf.length;i++) {
      var field = cf[i];

      if (firstadm && (i===cf.length || (field && field.admin)) && (!(i===0 && !isReseller() && field && field.admin))) {
        configfields.push(<tr><td></td><td><ActionBu text="bw.if.portal.save_config_fields" onClick={handleAktion('saveConfigFields')} /></td></tr>);
        if (i<cf.length && isReseller()) {
          configfields.push(<tr><td></td><td><br/><b>Admin only</b></td></tr>);
        }
        firstadm = false;
      }
      if (i===cf.length) break;
      if (field.admin && !isReseller()) break;
      
      var row = [];
      row.push(<td align="right">{tl('bw.if.portal.'+field.name.replace('.', ''))}</td>)
      if (field.opt === 'edit') {
        row.push(<input name={field.name} type="text" onChange={handleChange(field.name)} defaultValue={field.value} />)
      }
      else if (field.opt) {
        row.push(
          <select name={field.name} defaultValue={field.value} onChange={handleChange(field.name)}>
          {field.opt.map((el)=>(<option key={el.value} value={el.value}>{el.text}</option>))}
          </select>
        )
      } 
      configfields.push(<tr>{row}</tr>);
    }
  }

  var mri = null;
  
  if (aktionen.optionManualRoomInformation && portalinfo.length) {
    var mrirows = [];

    var mrihead = [];
    for (var j=0; j<aktionen.optionManualRoomInformation.length; j++) {
      mrihead.push(<td>{tl('bw.if.portal.'+aktionen.optionManualRoomInformation[j])}</td>);
    }
    mrirows.push(<tr><td><h3>{tl('bw.if.portal.roomdetails')}</h3></td>{mrihead}</tr>);

    for (i=0; i<portalinfo.length; i++) {
      var mrirow = [];
      if (portalinfo[i].schluessel.substr(0,3)==='rt_') {
        const rt = portalinfo[i].schluessel.substr(3);
        mrirow.push(<td key="name">{portalinfo[i].wert}</td>);
        for (j=0; j<aktionen.optionManualRoomInformation.length; j++) {
          const typ = aktionen.optionManualRoomInformation[j];
          var v = '';
          if (rmiList[rt]) {
            try {
              const rmi = JSON.parse(rmiList[rt]);
              v = rmi[typ];
            }
            catch(e) {
              
            }
          }
          if (typ==='gender') {
            mrirow.push(<td key={'field'+j}>
              <select name={'gender'+rt} defaultValue={v} onChange={handleChange('mri_gender_'+rt)}>
                <option value="0">{tl('bw.if.portal.gender0')}</option>
                <option value="1">{tl('bw.if.portal.gender1')}</option>
                <option value="2">{tl('bw.if.portal.gender2')}</option>
                <option value="4">{tl('bw.if.portal.gender4')}</option>
              </select>
            </td>);
          }
          else if (typ==='roomsize' || typ==='roomcnt' || typ==='defaultsize') {
            mrirow.push(<td key={'field'+j}>
              <input name={typ+rt} defaultValue={v} onChange={handleChange('mri_'+typ+'_'+rt)} type="number" style={{width:'4em'}} />
            </td>);
          }
        }
        
        mrirows.push(<tr key={'row'+i}>{mrirow}</tr>);
      }
    }
    
    mri = (<table>
            {mrirows}
            <tr><td></td><td colspan="3"><Button variant="contained" color="primary" onClick={handleAktion('RoomInfo')}>{tl('bw.if.portal.saveroomdetails')}</Button></td></tr>
           </table>);
  }
  const showyear = isHauptadmin()?' | '+aktionen.initYear+' | id='+aktionen.id_agent:''
  const rateSupport = isHauptadmin()&&aktionen.optionRate_support?'[RATE]':''
  
  return (
    <Card>
      <CardContent>
        <div style={{float:'left',width:'50%'}}>
         <h2>{aktionen.lang} {showyear} {rateSupport} <img src={icon} style={{width:'1em'}} alt="" /></h2>
         
    {aktionen.status==='corrupt' && 
        <><b>{tl("bw.if.portal.corruptTitel")}</b> {tl("bw.if.portal.corruptText")}</>
    }
        </div>
      {aktionen.aktionLoginURL?
        <div style={{float:'left',width:'44%', background:'#eee',padding:'1em 3%'}}>
          Log-in {aktionen.lang} backend<br />
          <a href={aktionen.aktionLoginURL} target="_blank" rel="noreferrer">{aktionen.aktionLoginURL}</a>
        </div>
      :null}
        <div style={{clear:'both'}} />
  {aktionen.status==='notconfigured' || aktionen.status==='corrupt'?
    <>
      <div dangerouslySetInnerHTML={{__html: aktionen.ActivationText}} />
      <hr />
      {isHauptadmin() && aktionen.status==='notconfigured' && 
      <>
        <PortalSetup />
        <hr />
      </>}
      {isReseller() && <PortalInfo />}
    </>
        
  :      
        <>
        <Tabs value={value} onChange={handleTabChange} aria-label="simple tabs example">
          <Tab label={tl("bw.if.portal.tab1")} />
          <Tab label={tl("bw.if.portal.tab2")}  />
          {isReseller() && <Tab label={tl("bw.if.portal.tab3")} />}
          {isHauptadmin() && <Tab label={tl("bw.if.portal.tab4")} />}
          <DoRefresh onClick={Reload} />
        </Tabs>      
{/* Availabilities --------------------------------------------------------        */}
        <TabPanel value={value} index={0} variant="scrollable">
    {aktionen.kurz !== 'hi' && overviewLoading && !overview.portrbt &&
          <div style={{padding:'3em', textAlign:'center'}}><CircularProgress /></div>
    }
    {aktionen.kurz !== 'hi' && overview.portrbt &&
          <div>
            <Button variant="contained" color="primary" value="-" onClick={handleScroll(-1)} > &lt;&lt; </Button>
            <TextField id="date" type="date" value={startDate.toISOString().substr(0,10)} onChange={handleDate} style={{marginLeft:'1em', width:'9em'}}/>
            <Button variant="contained" color="primary" value="+" onClick={handleScroll(1)} style={{marginLeft:'1em'}}> &gt;&gt; </Button>
            <Select native value={anzTage} onChange={handleAnzTage} style={{marginLeft:'14px'}} >
              <option value={5}>5 {tl('bw.if.portal.days')}</option>
              <option value={8}>8 {tl('bw.if.portal.days')}</option>
              <option value={12}>12 {tl('bw.if.portal.days')}</option>
              <option value={15}>15 {tl('bw.if.portal.days')}</option>
              <option value={29}>29 {tl('bw.if.portal.days')}</option>
              <option value={31}>31 {tl('bw.if.portal.days')}</option>
            </Select>
      {isReseller() &&
            <FormControlLabel control={<Switch checked={lnr} onChange={handleLnR} name="LnR" color="primary" />} label="Last new res" style={{marginLeft:'1em'}}/>
      }
            <table>
              <tbody>
                <tr><td align="right">{tage[0] && tage[0].substr(0,4)}</td><td></td>
        {tage.map((tag, i)=>{
          if (i>=tage.length-1 || tag.substr(4,2)!==tage[i+1].substr(4,2)) {
            var d = new Date(tag.substr(0,4)+'-'+tag.substr(4,2)+'-'+tag.substr(6,2));
            return (
                  <td key={tag} colSpan={spancnt+1} align="center" style={{borderLeft: '1px solid black'}}>{formatter.format(d)}</td>
            )
          }
          else {
            spancnt++;
          }
          return null;
        })}
                </tr>
                <tr><td></td><td></td>
        {tage.map(tag=>{
          var d = new Date(tag.substr(0,4)+'-'+tag.substr(4,2)+'-'+tag.substr(6,2));
          d = d.getDay();
          return (<td key={tag} align="center" style={{backgroundColor:(d===0 || d===6)?'#eee':'transparent'}}>{tag.substr(6)}</td>)
        })}
        
                </tr>
                <tr><td align="right">Price group</td><td></td>
        {tage.map((tag, i)=>{
          const gruppe = overview.gruppen[tag];
          const gruppe2 = overview.gruppen[tage[i+1]];
          if (i>=tage.length-1 || gruppe.preisgr!==gruppe2.preisgr) {
            var spn = spancnt2;
            spancnt2 = 1;
            return (
                  <td colSpan={spn} align="center" key={tag} style={{color:gruppe.preistext, background:gruppe.preisfarbe}}>
                    <div>{gruppe.preisgr}</div>
                  </td>
            )
          }
          else {
            spancnt2++;
          }
          return null;
        })}
                </tr>
        {hasYield &&
                <tr><td align="right">Price changed in yield manager</td><td></td>
        {tage.map((tag, i)=>(
          <td key={tag} style={{textAlign:'center',backgroundColor:overview.gruppen[tag].id_parent>0?'#ccc':'transparent'}}>{overview.gruppen[tag].id_parent>0?'*':''}</td>
        ))}
                </tr>
        }
                <tr><td align="right">Online group</td><td></td>
        {tage.map((tag, i)=>{
          const gruppe = overview.gruppen[tag];
          const gruppe2 = overview.gruppen[tage[i+1]];
          if (i>=tage.length-1 || gruppe.onlinegr!==gruppe2.onlinegr) {
            var spn = spancnt3;
            spancnt3 = 1;
            return (
                  <td colSpan={spn} align="center" key={tag} style={{color:gruppe.onlinetext, background:gruppe.onlinefarbe}}>{gruppe.onlinegr}</td>
            )
          }
          else {
            spancnt3++;
          }
          return null;
        })}
                </tr>
                <tr><td style={{textAlign:'right', borderBottom:"3px solid"}} >{tl('bw.if.portal.ratelegende')} [{overview.currency}]</td>
                <td>{Object.keys(details).length > 0?<ReduceAllIcon onClick={handleAllDetailsClick(false)} />:<ExpandAllIcon onClick={handleAllDetailsClick(true)} />}</td>
                
                  <td colSpan={tage.length} style={{textAlign:'center', borderBottom:"3px solid"}}>
        {overview.ratelist.map((rl, i)=>(
          <div onClick={handleRateClick(i)} key={i} 
            style={{backgroundColor:rl.color, position:'relative', cursor:'pointer', border:'1px solid black', fontSize:'0.8em', padding:'0 5px', float:'left', width:'33%', boxSizing: 'border-box'}}>
            {rl.ratename} 
            {aktiveRate===i?<CheckIcon color="primary" style={{position: 'absolute', left: 0, bottom: 0, width: '0.8em', height: '0.8em'}} />:null}
          </div>  
        ))}
                  
                  </td>
                </tr>
        {overview.portrbt.map((info, k)=>{
          var privat = info.geschlecht==="4" || info.geschlecht==="6";
          var spez = info.geschlecht==="6";
          const border = privat && overview.portrbt[k-1] && overview.portrbt[k-1].geschlecht!=="4"?{borderTop:"3px solid"}:{}; 
          border.verticalAlign = 'top';
          const technicalLabels = ['LastNewRes (interface)', 'main window', 'LM window', 'set window', 'booking window result', 'rate'];
          if (aktionen.optionClosedForArrival) technicalLabels.push('no arrival');
          if (aktionen.optionClosedForDeparture) technicalLabels.push('no departure');

          if (!detailData) return null;
          return (
               <React.Fragment key={k}> 
                <tr key={info.id}>
                  <td style={border}>{info.name}
                    <div style={{textAlign:'right', fontSize:'0.8em'}}>
            {detailData[info.id] && detailData[info.id].roomlist.length>1?
              detailData[info.id].roomlist.map((rl, i) => (
                <div key={i}>({detailData[info.id].roomoglist[i]}) {detailData[info.id].roomlist[i]?detailData[info.id].roomlist[i]:'no rooms assigned'}</div>
              ))
            :
              <div>{detailData[info.id] && detailData[info.id].roomlist[0]}</div>
            }      
                  </div></td>
                  <td style={{verticalAlign: 'top'}}>
                    {details[info.id]?<ExpandLessIcon onClick={handleDetailsClick(info.id)} />:<ExpandMoreIcon onClick={handleDetailsClick(info.id)} />}
                  </td>
          {tage.map((tag)=>{
            var avail = overview.availRate.avail[tag]
            var beds = avail[info.id];
            var anz = privat?Math.round(beds / Math.max(1, info.size)):beds;
            var rbt = overview.availRate.pogr_datum[tag];
            var pogrinfo = overview.availRate.pogr_info[rbt];
            return (
                  <td key={tag} style={border}>
                    <div style={{textAlign:'center', backgroundColor:(beds>0?'#E2F9CB':'#F9D8CB'), paddingBottom: '3px'}}>
                      {anz} {tl('bw.if.portal.'+(privat?(spez?'unit':'room'):'bed')+(anz!==1?'s':''))}
                    </div>
                    <div>
            {overview.ratelist.map(rl=>{
              var rateid = rl.ids[info.id];
              var preis = null;
              if (!pogrinfo.preis[info.id]) return null;
              if (pogrinfo) {
                preis = pogrinfo.preis[info.id][rateid];
              }
              var open = preis && preis.open;
              return (
                        <div key={rl.ratename} style={{width:'33%', float:'left', backgroundColor:(open?'#E2F9CB':'#F9D8CB'), color:(open?'#000':'#F9D8CB'), border:'1px solid black', boxSizing: 'border-box', fontSize:'0.8em'}}>
                          {preis && preis.default?Math.round(preis.default):'.'}
                        </div>
              )
            })}
                    </div>
                  </td>
            )
          })}    
                </tr>
          {details[info.id] && 
            <tr>
            <td style={{textAlign:'right', verticalAlign: 'top'}}>
              {detailData[info.id] && detailData[info.id].headlist.map((head)=>(
                <div key={head}>{head}</div>
              ))}
            </td>
            <td></td>
            {detailData[info.id] && detailData[info.id].tage.map((detlist)=>{
              var det = [];
              for(var i=0;i<detailData[info.id].headlist.length;i++) {
                var k = detailData[info.id].headlist[i];
                if (detlist[k] !== undefined) {
                  const value = detlist[k]===true?1:detlist[k];
                  const isAllow = k==='allow arrival' || k==='allow departure';
                  det.push(<div key={k} style={isAllow?statusStyle(value):{}}>{value}</div>);
                }
                else {
                  det.push(<div key={i}>&nbsp;</div>);
                }
              }
              
              
              return ( <td style={{textAlign:'right', verticalAlign: 'top'}}>{det}</td>);
            })}    
            </tr>
          }
          {details[info.id] &&
            <tr>
              <td style={{textAlign:'right'}}>
                {tl('bw.if.portal.technicalDetails')}
              </td>
              <td>
                {technicalDetails[info.id]?<ExpandLessIcon onClick={handleTechnicalDetailsClick(info.id)} />:<ExpandMoreIcon onClick={handleTechnicalDetailsClick(info.id)} />}
              </td>
              {tage.map(tag=>(
                <td key={tag} style={{textAlign:'center'}}>
            {isReseller() && rawDetails(info, tag).length>0 &&
                  <InfoOutlinedIcon onClick={openDetailDialog(info, tag)} style={{fontSize:'1em', cursor:'pointer'}} />
            }
                </td>
              ))}
            </tr>
          }
          {details[info.id] && technicalDetails[info.id] &&
            <tr>
              <td style={{textAlign:'right', verticalAlign:'top'}}>
                {technicalLabels.map(label=><div key={label}>{label}</div>)}
              </td>
              <td></td>
              {tage.map(tag=>{
                const day = detailsDay(overview, aktiveRate, info, tag);
                const calc = day && day._calc;
                const rateid = overview.ratelist[aktiveRate].ids[info.id];
                const restrictions = overview.availRate.restrictions[tag] && overview.availRate.restrictions[tag][info.id];
                const values = [
                  consolidatedCalcValue(calc, 'lnr'),
                  consolidatedCalcValue(calc, 'mainWindow'),
                  consolidatedCalcValue(calc, 'lastMinuteWindow'),
                  consolidatedCalcValue(calc, 'windowConfigured'),
                  consolidatedCalcValue(calc, 'dateInBookingWindow'),
                  rateValue(calc && calc.rate, rateid)
                ];
                if (aktionen.optionClosedForArrival) values.push(calcValue(restrictions && restrictions.noarrival));
                if (aktionen.optionClosedForDeparture) values.push(calcValue(restrictions && restrictions.nodeparture));
                return <td key={tag} style={{textAlign:'right', verticalAlign:'top'}}>{values.map((v, i)=><div key={i} style={i<5?statusStyle(v):{}}>{v}</div>)}</td>;
              })}
            </tr>
          }
        </React.Fragment>  
        )})}    

              </tbody>
            </table>
            <Dialog open={Boolean(detailDialog)} onClose={handleDetailDialogClose} maxWidth="md" fullWidth>
              <DialogTitle>
                {detailDialog && detailDialog.tag.substr(6,2)+'.'+detailDialog.tag.substr(4,2)+'.'+detailDialog.tag.substr(0,4)+' – '+detailDialog.info.name+' – '+overview.ratelist[aktiveRate].ratename}
              </DialogTitle>
              <DialogContent style={{maxHeight:'60vh'}}>
                <table style={{width:'100%', whiteSpace:'nowrap'}}>
                  <thead><tr><th align="left">room</th><th align="left">occupancy</th><th align="left">details2</th><th>LastNewRes</th><th>main</th><th>LM</th><th>set</th><th>result</th><th>room limit</th><th>keep free</th><th>max avail</th><th>quota</th><th>own</th><th>allocated</th><th>after keep</th><th>after quota</th><th>free</th><th>allow arr.</th><th>allow dep.</th></tr></thead>
                  <tbody>
                  {detailDialog && detailDialog.rows.map((row, i)=>(
                    <tr key={i}>
                      <td>{roomName(row.roomid)}</td><td>{row.occupancyType}</td><td>{row.result}</td>
                      <td align="center">{calcValue(row.calc && row.calc.lnr)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.mainWindow)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.lastMinuteWindow)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.windowConfigured)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.dateInBookingWindow)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.freeAfterRoomLimit)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.keepFree)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.maxAvail)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.quota)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.ownBookings)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.allocated)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.freeAfterKeepFree)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.freeAfterQuota)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.freeResult)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.allowArrival)}</td>
                      <td align="center">{calcValue(row.calc && row.calc.allowDeparture)}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </DialogContent>
              <DialogActions><Button onClick={handleDetailDialogClose}>Close</Button></DialogActions>
            </Dialog>
          </div>
      }
      {aktionen.kurz === 'hi' &&  
          <h2>Not available for this interface</h2>
      }
        </TabPanel>
{/* Actions --------------------------------------------------------        */}
        <TabPanel value={value} index={1}>
          <table>
            <tbody>
    {aktionen.status==='up' && 
      <>
      {aktionen.aktionChangeDown &&
              <tr style={{verticalAlign:"top"}} >
                <td align="right" style={{padding:"0.5em 0 4em 0"}}>{tl("bw.if.portal.InterfaceUp")}</td>
                <td><Switch checked={true} onChange={handleAktion('ChangeDown')} color="primary" inputProps={{ 'aria-label': 'primary checkbox' }} /></td>
              </tr>
      }
              <Synctime />
      {aktionen.result && aktionen.result.text &&
              <tr>
                  <td></td>
                  <td><div dangerouslySetInnerHTML={{__html: aktionen.result.text}} /></td>
              </tr>
      
      }
      {isReseller() && aktionen.aktionImportRes &&
              <tr>
                <td align="right">{aktionen.kurz} ID: <input name="portal_id" type="text" onChange={handleChange('portal_id')} data-lpignore="true" autoComplete="off" /></td>
                <td><ActionBu text="bw.if.portal.ReservationHolen" onClick={handleAktion('ImportRes')} /></td>
              </tr>
      }
      {aktionen.aktionImportRoomCat &&
              <tr>
                <td align="right">{tl("bw.if.portal.UpdateRoomtypesText")}</td>
                <td><ActionBu text="bw.if.portal.UpdateRoomtypesButton" onClick={handleAktion('ImportRoomCat')} /></td>
        {progAktion==='ImportRoomCat' &&        
                <td>{progress===false?<DoneIcon />:<HourglassEmptyIcon />}</td>
        }        
              </tr>
      }
      {isReseller() && aktionen.aktionRoomCatHTML &&
              <tr>
                <td align="right">{tl("bw.if.portal.UpdateRoomtypesText")}</td>
                <td><TextField onChange={handleChange('room_html')} /><ActionBu text="bw.if.portal.UpdateRoomtypesButton" onClick={handleAktion('ImportRoomCatHTML')} /></td>
              </tr>
      }
      {aktionen.aktionUpdateAvail &&
              <tr>
                <td align="right">{tl("bw.if.portal.updateAvailText")}</td>
                <td><ActionBu text="bw.if.portal.updateAvailButton" onClick={handleAktion('UpdateAvail')} /></td>
      {progAktion==='UpdateAvail' &&        
                <td>{progress===false?<DoneIcon />:<HourglassEmptyIcon />}</td>
      }        
              </tr>
      }
      {isHauptadmin() && aktionen.aktionResetCache &&
              <tr>
                <td align="right">{tl("bw.if.portal.resetCacheText")}</td>
                <td><ActionBu text="bw.if.portal.resetCacheButton" onClick={handleAktion('ResetCache')} /></td>
      {progAktion==='ResetCache' && <td><DoneIcon /></td>}        
              </tr>
      }
      {isHauptadmin() && aktionen.aktionFirstErrorReset &&
              <tr>
                <td align="right">{tl("bw.if.portal.FirstErrorResetText")}</td>
                <td><ActionBu text="bw.if.portal.FirstErrorResetButton" onClick={handleAktion('FirstErrorReset')} /></td>
      {progAktion==='FirstErrorReset' &&        
                <td>{progress===false?<DoneIcon />:<HourglassEmptyIcon />}</td>
      }        
              </tr>
      }
      {aktionen.aktionConfig_fields && 
        <>
          <tr><td><br />&nbsp;</td></tr>
          {configfields}
        </>
      }
              <tr>
                <td align="right">{tl("bw.if.portal.timeNow")}</td>
                <td>{aktionen.timeNow}</td>
              </tr>
              <tr >
                <td align="right">{tl("bw.if.portal.timeLast")}</td>
                <td>{aktionen.timeLastNewToday1}</td>
                {isHauptadmin() && <td>{aktionen.timeLastNewToday2}</td>}
              </tr>
      </>
    }
    {aktionen.status==='down' && 
      <>
      {aktionen.aktionChangeUp &&
              <tr>
                <td align="right">{tl("bw.if.portal.InterfaceDown")}</td>
                <td><Switch checked={false} onChange={handleAktion('ChangeUp')} color="primary" inputProps={{ 'aria-label': 'primary checkbox' }} /></td>
              </tr>
      }
              <Synctime />
      </>
    }
    {aktionen.status==='corrupt' && 
      <>
              <tr>
                <td><h2>{tl("bw.if.portal.corruptTitel")}</h2>{tl("bw.if.portal.corruptText")}</td>
              </tr>
      </>
    }
            </tbody>
          </table>
          {mri}
        </TabPanel>
{/* Settings (PortailInfo) --------------------------------------------------------        */}
    {isReseller() &&
        <TabPanel key="tab2" value={value} index={2} variant="scrollable">
          <PortalInfo />
        </TabPanel>
    }
{/* Settings (Import/Export) ------------------------------------------------------        */}
    {isHauptadmin() &&
        <TabPanel key="tab3" value={value} index={3} variant="scrollable">
          <ImportExport />
        </TabPanel>
    }
        </>
  }               
      </CardContent>
    </Card>
  )
};

export default IfPortal;